// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n4aW","newExpiryDate":"styles_newExpiryDate__2q7MO","footer":"styles_footer__2IGSs"};